export default "__VITE_ASSET__793b29bc__"